export default __webpack_public_path__ + "static/media/winston-intro2.b0e26cb6.mp3";